import {FC} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  Grid,
} from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import { Formik, Form } from "formik";
import Textfield from "../FormsUI/Textfield";
import { Button } from "@material-ui/core";
import { IdentityVerificationValidation } from "../../helpers/Validations";
import {BaiscInfoStyle} from "../Styles/IdentityVerificationStyles";


const INITIAL_FORM_STATE = {
  firstName: "",
  lastName: "",
  address: "",
  town: "",
  city: "",
  country: "",
  national: "",
};



const BasicInformation:FC = () => {
  const theme = useTheme();
  const classes = BaiscInfoStyle();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      <Formik
        initialValues={{
          ...INITIAL_FORM_STATE,
        }}
        validationSchema={IdentityVerificationValidation}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        <Form>
          <Grid className="mb-12" container spacing={isActive ? 2 : 3}>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                First Name*
              </Typography>
              <Textfield
                name="firstName"
                placeholder="Enter First Name"
                margin="dense"
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Last Name*
              </Typography>
              <Textfield
                name="lastName"
                placeholder="Enter Last Name"
                margin="dense"
              />
            </Grid>
          </Grid>
          <Grid className="mb-12" container spacing={isActive ? 2 : 3}>
            <Grid item md={6} xs={12}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Address*
              </Typography>
              <Textfield
                name="address"
                placeholder="Enter Address"
                margin="dense"
              />
            </Grid>
          </Grid>
          <Grid className="mb-12" container spacing={isActive ? 2 : 3}>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Town*
              </Typography>
              <Textfield
                name="town"
                placeholder="Enter Town"
                margin="dense"
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                City*
              </Typography>
              <Textfield
                name="city"
                placeholder="Enter City"
                margin="dense"
              />
            </Grid>
          </Grid>
          <Grid container spacing={isActive ? 2 : 3}>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Country*
              </Typography>
              <Textfield
                name="country"
                placeholder="Enter Country"
                margin="dense"
              />
            </Grid>
            <Grid item md={3} xs={6}>
              <Typography
                variant="subtitle1"
                color="secondary"
                className="fw-normal"
              >
                Nationality*
              </Typography>
              <Textfield
                name="national"
                placeholder="Enter Nationality"
                margin="dense"
              />
            </Grid>
          </Grid>
          <Box display="flex" alignItems="center" justifyContent={isActiveXS ? "space-between" : ""}  mt={isActiveXS ? 2 : 5}>
              <Button type="submit" variant="contained" color="secondary" size="large">
                Next
              </Button>
              <Button
                className="socialbtn"
                variant="outlined"
                color="secondary"
                size="large"
              >
                Back
              </Button>
          </Box>
        </Form>
      </Formik>
    </Box>
  );
};
export default BasicInformation;
